/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "184")
  

// 接口文档

  
    
export interface IAPI19583ResListItem {
  
  /** 用户编号 */
  code?: string;
  
  /** 用户名称 */
  name?: string;
  
  /** 钉钉编号 */
  dingdingUserId?: string;
  
  /** 是否离职,true：离职,false：在职 */
  leaveJob?: boolean;
  
};
    
  



export interface API19583Req {
  
  /** 用户名关键字 */
  name?: string;
    
  /** -1:全部人员；0：仅在职人员；1：仅离职人员,默认查询在职人员,,@seecom.ywwl.supply.chain.common.enums.user.AdminUserIsQuitEnum */
  isQuit?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API19583Res {
  /** T  */
  list?: IAPI19583ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 19583 分页查询遥望云用户列表

export interface IUseGetAPI19583Return {
  /** 分页查询遥望云用户列表: 接口请求状态 */
  isAPI19583Loading: boolean;
  /** 分页查询遥望云用户列表: 接口请求返回数据 */
  dataAPI19583: API19583Res;
  /**  分页查询遥望云用户列表: 接口数据请求方法 */
  fetchAPI19583Data: (inputs: API19583Req, config?: YWRequestConfig) => Promise<API19583Res>;
  /** 分页查询遥望云用户列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI19583 = ():IUseGetAPI19583Return => {
  let isMount = true;
  const [isAPI19583Loading, setIsAPI19583Loading] = useState(false);
  const [dataAPI19583, setDataAPI19583] = useState<API19583Res>({} as API19583Res);
  const requestUrl = `${basePath}/ywwl-supply-chain-admin/new/admin/saleUser/list`;

  const fetchAPI19583Data = async (inputs: API19583Req, config?: YWRequestConfig): Promise<API19583Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API19583Req>) || {}) as API19583Req;
    
  
    if ( isMount ) {
      setIsAPI19583Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API19583Res>(`${basePath}/ywwl-supply-chain-admin/new/admin/saleUser/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI19583(res || {} as API19583Res);
        setIsAPI19583Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI19583Loading(false);
      }
      return false as unknown as API19583Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI19583Loading,
    dataAPI19583,
    fetchAPI19583Data,
    requestUrl,
  }
}

